module.exports = __webpack_public_path__ + "img/mal_2.07f47b76.png";